var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5308",
    "data-name": "Group 5308",
    transform: "translate(-1482 -352)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 45,
    height: 45,
    rx: 22.5,
    transform: "translate(1482 352)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5304",
    "data-name": "Group 5304",
    transform: "translate(1497 367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bars-staggered",
    d: "M0,1.446A1.444,1.444,0,0,0,1.446,2.892H16.873a1.446,1.446,0,1,0,0-2.892H1.446A1.444,1.444,0,0,0,0,1.446Z",
    transform: "translate(14.999 2.045) rotate(135)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bars-staggered-2",
    "data-name": "bars-staggered",
    d: "M0,1.446A1.444,1.444,0,0,1,1.446,0H16.874a1.446,1.446,0,0,1,0,2.893H1.446A1.444,1.444,0,0,1,0,1.446Z",
    transform: "translate(2.046 0) rotate(45)",
    fill: "#e23744"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.7dee9662c3051096dbadd5d5262a010f.svg";
export { ForwardRef as ReactComponent };